import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from '../services/components/Footer';
import SEOHead from '../../components/SEOHead';

type FilterType = 'all' | 'before-after' | 'living' | 'kitchen' | 'dining' | 'bedroom' | 'bathroom' | 'basement' | 'outdoor' | 'traditional' | 'contemporary';

interface GalleryItem {
  id: number;
  image: string;
  title: string;
  category: FilterType[];
  location: string;
  description: string;
}

const galleryItems: GalleryItem[] = [
  // Before & After Transformations
  {
    id: 1,
    image: 'https://public.readdy.ai/ai/img_res/f77d1ad03b3ecf1bb6642bdc28171021.jpg',
    title: 'Complete Living Room Transformation',
    category: ['all', 'before-after', 'living', 'contemporary'],
    location: 'Seattle, WA',
    description: 'Full renovation from outdated to modern luxury rental'
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Before%20and%20after%20comparison%20of%20dated%20kitchen%20renovation%20into%20stunning%20modern%20chef%20kitchen%20with%20white%20cabinets%20stainless%20steel%20appliances%20marble%20countertops%2C%20American%20home%20renovation%2C%20realistic%20transformation%20photography%20showing%20actual%20construction%20progress&width=800&height=600&seq=gallery-ba-002&orientation=landscape',
    title: 'Kitchen Renovation Journey',
    category: ['all', 'before-after', 'kitchen', 'contemporary'],
    location: 'Portland, OR',
    description: 'From dated to dream kitchen in 6 weeks'
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Before%20and%20after%20basement%20conversion%20showing%20unfinished%20concrete%20space%20transformed%20into%20cozy%20modern%20Airbnb%20guest%20suite%20with%20bedroom%20and%20kitchenette%2C%20American%20home%20basement%20renovation%2C%20realistic%20construction%20transformation%20photography&width=800&height=600&seq=gallery-ba-003&orientation=landscape',
    title: 'Basement to Guest Suite',
    category: ['all', 'before-after', 'basement', 'contemporary'],
    location: 'Austin, TX',
    description: 'Unused basement converted to profitable rental space'
  },
  
  // Living Rooms
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20traditional%20American%20living%20room%20with%20classic%20furniture%2C%20warm%20beige%20tones%2C%20crown%20molding%2C%20fireplace%20mantel%2C%20comfortable%20sofas%2C%20table%20lamps%2C%20area%20rug%2C%20realistic%20residential%20interior%20photography%2C%20cozy%20inviting%20atmosphere%20perfect%20for%20Airbnb%20guests&width=800&height=600&seq=gallery-living-001&orientation=landscape',
    title: 'Traditional Living Room',
    category: ['all', 'living', 'traditional'],
    location: 'Charleston, SC',
    description: 'Classic elegance with modern comfort'
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Modern%20contemporary%20American%20living%20room%20with%20minimalist%20furniture%2C%20neutral%20gray%20and%20white%20color%20scheme%2C%20large%20windows%20with%20natural%20light%2C%20sleek%20sectional%20sofa%2C%20geometric%20decor%2C%20realistic%20interior%20design%20photography%2C%20bright%20airy%20space&width=800&height=600&seq=gallery-living-002&orientation=landscape',
    title: 'Contemporary Living Space',
    category: ['all', 'living', 'contemporary'],
    location: 'Denver, CO',
    description: 'Minimalist design maximizing natural light'
  },
  
  // Kitchens
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20traditional%20American%20kitchen%20with%20white%20shaker%20cabinets%2C%20farmhouse%20sink%2C%20butcher%20block%20island%2C%20pendant%20lighting%2C%20subway%20tile%20backsplash%2C%20stainless%20appliances%2C%20realistic%20residential%20kitchen%20photography%2C%20warm%20inviting%20cooking%20space&width=800&height=600&seq=gallery-kitchen-001&orientation=landscape',
    title: 'Farmhouse Kitchen',
    category: ['all', 'kitchen', 'traditional'],
    location: 'Nashville, TN',
    description: 'Timeless farmhouse style with modern amenities'
  },
  {
    id: 7,
    image: 'https://readdy.ai/api/search-image?query=Sleek%20modern%20American%20kitchen%20with%20glossy%20white%20cabinets%2C%20quartz%20waterfall%20countertops%2C%20stainless%20steel%20appliances%2C%20minimalist%20design%2C%20under%20cabinet%20lighting%2C%20realistic%20contemporary%20kitchen%20photography%2C%20clean%20lines%20and%20bright%20space&width=800&height=600&seq=gallery-kitchen-002&orientation=landscape',
    title: 'Modern Chef\'s Kitchen',
    category: ['all', 'kitchen', 'contemporary'],
    location: 'San Francisco, CA',
    description: 'High-end finishes for culinary enthusiasts'
  },
  
  // Dining Rooms
  {
    id: 8,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20traditional%20American%20dining%20room%20with%20dark%20wood%20table%2C%20upholstered%20chairs%2C%20crystal%20chandelier%2C%20wainscoting%20walls%2C%20china%20cabinet%2C%20realistic%20residential%20dining%20space%20photography%2C%20formal%20entertaining%20area&width=800&height=600&seq=gallery-dining-001&orientation=landscape',
    title: 'Formal Dining Room',
    category: ['all', 'dining', 'traditional'],
    location: 'Boston, MA',
    description: 'Perfect for hosting memorable dinners'
  },
  {
    id: 9,
    image: 'https://readdy.ai/api/search-image?query=Contemporary%20American%20dining%20area%20with%20modern%20table%2C%20mid-century%20chairs%2C%20statement%20pendant%20light%2C%20open%20concept%20design%2C%20neutral%20colors%2C%20realistic%20interior%20photography%2C%20casual%20elegant%20dining%20space&width=800&height=600&seq=gallery-dining-002&orientation=landscape',
    title: 'Open Concept Dining',
    category: ['all', 'dining', 'contemporary'],
    location: 'Phoenix, AZ',
    description: 'Seamless flow between kitchen and dining'
  },
  
  // Bedrooms
  {
    id: 10,
    image: 'https://readdy.ai/api/search-image?query=Cozy%20traditional%20American%20bedroom%20with%20four%20poster%20bed%2C%20quilted%20bedding%2C%20nightstands%20with%20lamps%2C%20dresser%2C%20warm%20color%20palette%2C%20realistic%20residential%20bedroom%20photography%2C%20comfortable%20guest%20room%20atmosphere&width=800&height=600&seq=gallery-bedroom-001&orientation=landscape',
    title: 'Traditional Guest Bedroom',
    category: ['all', 'bedroom', 'traditional'],
    location: 'Savannah, GA',
    description: 'Comfortable retreat for guests'
  },
  {
    id: 11,
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20American%20bedroom%20with%20platform%20bed%2C%20crisp%20white%20linens%2C%20floating%20nightstands%2C%20abstract%20art%2C%20neutral%20tones%2C%20realistic%20contemporary%20bedroom%20photography%2C%20serene%20sleeping%20space&width=800&height=600&seq=gallery-bedroom-002&orientation=landscape',
    title: 'Contemporary Master Suite',
    category: ['all', 'bedroom', 'contemporary'],
    location: 'Miami, FL',
    description: 'Serene sanctuary with clean lines'
  },
  
  // Bathrooms
  {
    id: 12,
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20traditional%20American%20bathroom%20with%20clawfoot%20tub%2C%20pedestal%20sink%2C%20marble%20tiles%2C%20vintage%20fixtures%2C%20elegant%20mirror%2C%20realistic%20residential%20bathroom%20photography%2C%20spa-like%20atmosphere&width=800&height=600&seq=gallery-bathroom-001&orientation=landscape',
    title: 'Classic Spa Bathroom',
    category: ['all', 'bathroom', 'traditional'],
    location: 'New Orleans, LA',
    description: 'Vintage charm meets modern luxury'
  },
  {
    id: 13,
    image: 'https://readdy.ai/api/search-image?query=Modern%20American%20bathroom%20with%20walk-in%20glass%20shower%2C%20floating%20vanity%2C%20large%20format%20tiles%2C%20chrome%20fixtures%2C%20backlit%20mirror%2C%20realistic%20contemporary%20bathroom%20photography%2C%20clean%20minimalist%20design&width=800&height=600&seq=gallery-bathroom-003&orientation=landscape',
    title: 'Modern Bathroom Retreat',
    category: ['all', 'bathroom', 'contemporary'],
    location: 'Los Angeles, CA',
    description: 'Sleek design with premium finishes'
  },
  
  // Basements
  {
    id: 14,
    image: 'https://readdy.ai/api/search-image?query=Finished%20traditional%20American%20basement%20with%20wood%20paneling%2C%20comfortable%20sectional%20sofa%2C%20entertainment%20center%2C%20recessed%20lighting%2C%20area%20rug%2C%20realistic%20residential%20basement%20photography%2C%20cozy%20family%20room%20atmosphere&width=800&height=600&seq=gallery-basement-001&orientation=landscape',
    title: 'Traditional Basement Living',
    category: ['all', 'basement', 'traditional'],
    location: 'Chicago, IL',
    description: 'Warm and inviting lower level space'
  },
  {
    id: 15,
    image: 'https://readdy.ai/api/search-image?query=Contemporary%20American%20basement%20apartment%20with%20modern%20kitchenette%2C%20studio%20layout%2C%20bright%20LED%20lighting%2C%20laminate%20flooring%2C%20compact%20furniture%2C%20realistic%20basement%20conversion%20photography%2C%20independent%20rental%20unit&width=800&height=600&seq=gallery-basement-002&orientation=landscape',
    title: 'Basement Studio Apartment',
    category: ['all', 'basement', 'contemporary'],
    location: 'Minneapolis, MN',
    description: 'Self-contained rental generating income'
  },
  
  // Outdoor Spaces
  {
    id: 16,
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20traditional%20American%20front%20yard%20with%20manicured%20lawn%2C%20flower%20beds%2C%20brick%20walkway%2C%20white%20picket%20fence%2C%20mature%20trees%2C%20welcoming%20entrance%2C%20realistic%20residential%20landscaping%20photography%2C%20curb%20appeal&width=800&height=600&seq=gallery-outdoor-001&orientation=landscape',
    title: 'Charming Front Yard',
    category: ['all', 'outdoor', 'traditional'],
    location: 'Richmond, VA',
    description: 'First impressions that wow guests'
  },
  {
    id: 17,
    image: 'https://readdy.ai/api/search-image?query=Modern%20American%20backyard%20with%20wooden%20deck%2C%20outdoor%20furniture%2C%20string%20lights%2C%20fire%20pit%2C%20contemporary%20landscaping%2C%20privacy%20fence%2C%20realistic%20outdoor%20living%20space%20photography%2C%20entertainment%20area&width=800&height=600&seq=gallery-outdoor-002&orientation=landscape',
    title: 'Contemporary Backyard Oasis',
    category: ['all', 'outdoor', 'contemporary'],
    location: 'San Diego, CA',
    description: 'Perfect outdoor entertaining space'
  },
  {
    id: 18,
    image: 'https://readdy.ai/api/search-image?query=Traditional%20American%20backyard%20with%20stone%20patio%2C%20garden%20furniture%2C%20pergola%2C%20lush%20landscaping%2C%20flower%20gardens%2C%20realistic%20residential%20outdoor%20photography%2C%20peaceful%20retreat%20atmosphere&width=800&height=600&seq=gallery-outdoor-003&orientation=landscape',
    title: 'Traditional Garden Patio',
    category: ['all', 'outdoor', 'traditional'],
    location: 'Atlanta, GA',
    description: 'Tranquil outdoor living area'
  }
];

export default function GalleryPage() {
  const [activeFilter, setActiveFilter] = useState<FilterType>('all');
  const [selectedImage, setSelectedImage] = useState<GalleryItem | null>(null);
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const filteredItems = activeFilter === 'all' 
    ? galleryItems 
    : galleryItems.filter(item => item.category.includes(activeFilter));

  const filters: { label: string; value: FilterType }[] = [
    { label: 'All Projects', value: 'all' },
    { label: 'Before & After', value: 'before-after' },
    { label: 'Living Rooms', value: 'living' },
    { label: 'Kitchens', value: 'kitchen' },
    { label: 'Dining Rooms', value: 'dining' },
    { label: 'Bedrooms', value: 'bedroom' },
    { label: 'Bathrooms', value: 'bathroom' },
    { label: 'Basements', value: 'basement' },
    { label: 'Outdoor Spaces', value: 'outdoor' },
    { label: 'Traditional Style', value: 'traditional' },
    { label: 'Contemporary Style', value: 'contemporary' }
  ];

  const activeFilterLabel = filters.find(f => f.value === activeFilter)?.label || 'All Projects';

  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const schema = {
    "@context": "https://schema.org",
    "@type": "ImageGallery",
    "name": "Aire University Project Gallery",
    "description": "Browse our portfolio of successful Airbnb property transformations across America. See before and after photos of living rooms, kitchens, bedrooms, bathrooms, basements, and outdoor spaces.",
    "url": `${siteUrl}/gallery`,
    "provider": {
      "@type": "ProfessionalService",
      "name": "Aire University",
      "telephone": "+1-302-500-3373",
      "email": "Aireuniversity@gmail.com",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "2043 Pulaski Hwy",
        "addressLocality": "Newark",
        "addressRegion": "DE",
        "postalCode": "19702",
        "addressCountry": "US"
      }
    },
    "numberOfItems": galleryItems.length,
    "about": "Airbnb property renovation and transformation portfolio"
  };

  return (
    <>
      <SEOHead
        title="Airbnb Property Transformation Gallery | Before & After Photos | Aire University"
        description="View our portfolio of successful Airbnb property renovations and transformations. Browse before and after photos of living rooms, kitchens, bedrooms, bathrooms, and outdoor spaces across America. Get inspired for your rental property."
        keywords="Airbnb renovation photos, property transformation gallery, vacation rental design, before after Airbnb, rental property photos, Airbnb interior design"
        schema={schema}
      />
      <div className="min-h-screen bg-white">
        <Navbar />
        
        {/* Hero Section */}
        <section className="pt-32 pb-16 bg-gradient-to-br from-gray-50 to-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center max-w-3xl mx-auto">
              <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
                Transformation Gallery
              </h1>
              <p className="text-xl text-gray-600 leading-relaxed">
                Explore our portfolio of successful Airbnb property transformations. From complete renovations to stunning finished spaces, see how we help homeowners create profitable rental properties across America.
              </p>
            </div>
          </div>
        </section>

        {/* Filter Section - Dropdown Style */}
        <section className="py-8 bg-white border-b border-gray-200">
          <div className="max-w-7xl mx-auto px-6">
            <div className="flex items-center justify-between">
              <div className="text-gray-600">
                Showing <strong>{filteredItems.length}</strong> of <strong>{galleryItems.length}</strong> projects
              </div>
              
              <div className="relative">
                <button
                  onClick={() => setIsFilterOpen(!isFilterOpen)}
                  className="flex items-center gap-3 px-6 py-3 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium text-gray-900 transition-all cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-filter-3-line text-xl"></i>
                  <span>{activeFilterLabel}</span>
                  <i className={`ri-arrow-down-s-line text-xl transition-transform ${isFilterOpen ? 'rotate-180' : ''}`}></i>
                </button>

                {isFilterOpen && (
                  <>
                    <div 
                      className="fixed inset-0 z-40" 
                      onClick={() => setIsFilterOpen(false)}
                    ></div>
                    <div className="absolute right-0 mt-2 w-64 bg-white rounded-xl shadow-2xl border border-gray-200 py-2 z-50 max-h-96 overflow-y-auto">
                      {filters.map((filter) => (
                        <button
                          key={filter.value}
                          onClick={() => {
                            setActiveFilter(filter.value);
                            setIsFilterOpen(false);
                          }}
                          className={`w-full text-left px-4 py-3 hover:bg-gray-50 transition-colors cursor-pointer flex items-center justify-between ${
                            activeFilter === filter.value ? 'bg-[#FF6B6B]/10 text-[#FF6B6B] font-semibold' : 'text-gray-700'
                          }`}
                        >
                          <span>{filter.label}</span>
                          {activeFilter === filter.value && (
                            <i className="ri-check-line text-xl"></i>
                          )}
                        </button>
                      ))}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </section>

        {/* Gallery Grid */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredItems.map((item) => (
                <div
                  key={item.id}
                  className="group cursor-pointer"
                  onClick={() => setSelectedImage(item)}
                >
                  <div className="relative rounded-2xl overflow-hidden shadow-lg mb-4 h-80">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                        <p className="text-sm font-medium mb-2">
                          <i className="ri-map-pin-line mr-1"></i>
                          {item.location}
                        </p>
                        <p className="text-lg font-semibold">View Details</p>
                      </div>
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h3>
                  <p className="text-gray-600">{item.description}</p>
                </div>
              ))}
            </div>

            {filteredItems.length === 0 && (
              <div className="text-center py-16">
                <i className="ri-image-line text-6xl text-gray-300 mb-4"></i>
                <p className="text-xl text-gray-500">No projects found in this category</p>
              </div>
            )}
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-24 bg-gradient-to-br from-[#FF6B6B] to-[#ff5252]">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
              Ready to Transform Your Property?
            </h2>
            <p className="text-xl text-white/90 mb-8 leading-relaxed">
              Let's discuss how we can help you create a successful Airbnb rental that generates consistent income.
            </p>
            <Link
              to="/contact"
              className="inline-block bg-white text-[#FF6B6B] px-10 py-4 rounded-lg font-semibold text-lg hover:shadow-2xl transition-all cursor-pointer whitespace-nowrap"
            >
              Schedule Your Consultation
            </Link>
          </div>
        </section>

        {/* Image Modal */}
        {selectedImage && (
          <div
            className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-6"
            onClick={() => setSelectedImage(null)}
          >
            <button
              className="absolute top-6 right-6 text-white text-4xl hover:text-gray-300 transition-colors cursor-pointer w-12 h-12 flex items-center justify-center"
              onClick={() => setSelectedImage(null)}
            >
              <i className="ri-close-line"></i>
            </button>
            <div className="max-w-6xl w-full" onClick={(e) => e.stopPropagation()}>
              <img
                src={selectedImage.image}
                alt={selectedImage.title}
                className="w-full h-auto rounded-2xl shadow-2xl mb-6"
              />
              <div className="text-white text-center">
                <h3 className="text-3xl font-bold mb-3">{selectedImage.title}</h3>
                <p className="text-lg text-gray-300 mb-2">
                  <i className="ri-map-pin-line mr-2"></i>
                  {selectedImage.location}
                </p>
                <p className="text-xl text-gray-200">{selectedImage.description}</p>
              </div>
            </div>
          </div>
        )}

        <Footer />
      </div>
    </>
  );
}
